import PropTypes from 'prop-types';
import { parseSortOptions } from '@/utils/categUtils';
import { SORT } from '@/constants/categ';
import DropdownDs from '@/components/common/design-system/Dropdown.ds';

export const SortDesktop = ({ t, selectedSort, onSortChange, isProducerCategory }) => {
  const enhancedSort = [
    ...SORT,
    isProducerCategory && { value: 12, label: 'byMillesimeAsc' },
    isProducerCategory && { value: 13, label: 'byMillesimeDesc' },
  ].filter(Boolean);

  const selectedOption = enhancedSort.find((opt) => opt.value === selectedSort);

  const handleOnChange = (element) => {
    onSortChange(element);
  };

  return (
    <DropdownDs
      onChange={handleOnChange} selected={selectedOption} options={parseSortOptions(t, enhancedSort)} isFullWidth={false}
    />
  );
};

SortDesktop.propTypes = {
  t: PropTypes.func.isRequired,
  selectedSort: PropTypes.number,
  onSortChange: PropTypes.func.isRequired,
};

export default SortDesktop;
